<template>
	<b-container>
		<div class="search-title">
			<h1>搜索关键字“<span style="color: #cfaf75">{{ this.searchWord }}</span>”，为您匹配以下信息:</h1>
			<div class="news-list">
				<router-link to="/news/detail">
					<div
						class="list-item"
						v-for="(item, index) in newsList"
						:key="index"
					>
						<div class="text-part">
							<div class="date">
								<div class="date-title">
									{{ item.categoryName }}
								</div>
								<div class="date-time">
									{{ String(item.createTime).split(' ')[0] }}
								</div>
							</div>
							<div class="content pl-3 pr-3">
								<div class="content-title">
									<h1 v-html="dealTitle(item.title)"></h1>
								</div>
								<div class="content-text">
									{{ item.describe }}
								</div>
							</div>
						</div>
						<div class="img-part img-wrap img-hovor">
							<img width="100%"
								 height="100%"
								 :src="item.titleImg"/>
						</div>
					</div>
				</router-link>
			</div>
		</div>
	</b-container>
</template>
<script>
export default {
	data() {
		return {
			newsList: [],
			searchWord: '',
		}
	},
	created() {
		this.searchWord = this.$route.query.searchword
		this.newsList = JSON.parse(localStorage.getItem('SEARCH_CONTENT'))
        
    },
    methods:{
        dealTitle(str){
            var arr = str.split(this.searchWord)
            return arr.join(`<span style="color: #cfaf75">${this.searchWord}</span>`)
        }
    }
}
</script>
<style lang="scss" scoped>
.search-title h1 {
	font-size: 1.28rem;
	font-weight: bold;
	color: #333333;
	height: 6rem;
	line-height: 6rem;
}
.news-list {
		a {
			text-decoration: none;
		}
		.list-item {
			display: flex;
			flex-direction: row-reverse;
			align-items: center;
			padding: 2rem 0 1rem 0;
			cursor: pointer;
			text-decoration: none;
			border-bottom: 0.1rem solid #ebebeb;
			box-sizing: border-box;
           

			.text-part {
				display: flex;
				flex-direction: column-reverse;
				flex: 2;
				justify-content: space-between;
				padding: 0.5rem;
				.date {
                    display: flex;
					.date-title {
                        padding-left: 1rem;
						font-size: 1rem;
						color: #333333;
						min-height: 2rem;
					}
					.date-time {
                        margin-left: 2rem;
						font-size: 1rem;
						color: #999999;
					}
				}
				.content {
					.content-title h1{
						font-size: 2.6rem;
						color: #4a4a4a;
                        overflow: hidden;
                        text-overflow: ellipsis;
					}
					.content-text {
						height: 8.5rem;
						margin-top: 1rem;
						font-size: 1rem;
						color: #666666;
						overflow: hidden;
					}
                    @media (max-width: 768px) {
                        .content-text {
							height: 3rem;
						}
                    }
				}
			}
			.img-part {
				flex: 1;
				height: 8rem;
			}
			.img-wrap {
				margin: 0;
                min-height: 16rem;
			}
		}
		.list-item:hover {
			background: #f7f7f7;
		}
	}
</style>
